import { configureStore } from '@reduxjs/toolkit';
import userSlice from './features/user';
import linesSlice from './features/lines';
import chatSlice from './features/chat';
import appSlice from './features/app';
import { IAppConfiguration, IRootState, IRootStateLine } from './model/store.model';

export const store = configureStore({
    reducer: {
        user: userSlice,
        itemTimes: linesSlice,
        chatResponse: chatSlice,
        app: appSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type IStore = {
    user?: IRootState;
    itemTimes?: IRootStateLine;
    chatResponse: any;
    app: IAppConfiguration;
};

export const getUser = (state: IStore) => state;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, products: ProductsState}
export type AppDispatch = typeof store.dispatch;
